var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFilteredIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:rgba(0,0,0,0);}.b{fill:#013243;}.c{fill:red;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-272 -24)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M0,0H24m0,24H0",
    transform: "translate(272 24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M4.25,5.61C6.27,8.2,10,13,10,13v6a1,1,0,0,0,1,1h2a1,1,0,0,0,1-1V13s3.72-4.8,5.74-7.39A1,1,0,0,0,18.95,4H5.04A1,1,0,0,0,4.25,5.61Z",
    transform: "translate(272 24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M0,0H24V24H0Z",
    transform: "translate(272 24)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 9,
    height: 9,
    rx: 4.5,
    transform: "translate(287 24)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilteredIcon);
export default __webpack_public_path__ + "static/media/filtered-icon.5819e405e135310c553e7e59c611d13c.svg";
export { ForwardRef as ReactComponent };